import script from "./ThemeSlider.vue?vue&type=script&lang=ts&setup=true"
export * from "./ThemeSlider.vue?vue&type=script&lang=ts&setup=true"

import "./ThemeSlider.vue?vue&type=style&index=0&id=70a14c5f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\git\\git\\chess-com-frontend-test\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70a14c5f"]])

export default __exports__